import { Prize } from '../types'

export type DemoContestItem = {
  id: number
  activatesAt: string
  humanActivatesAt: string
  contestType: string
  endsAt: string
  humanEndsAt: string
  mtAccountGroup: string
  mtInitialBalance: string
  mtLeverage: number
  mtPlatform: string
  name: string
  numWinners: number
  participantCount: number
  prizeFund: number
  prizes: Prize[]
  registrationAt: string
  humanRegistrationAt: string
  humanCreatedAt: string
  humanUpdatedAt: string
  resultsAt: string
  status: string
  bonusPercent: string
  bonusCalculationType: string
  firstTeamAccountGroup: string
  secondTeamAccountGroup: string
  updatedBy: { email: string; updatedBy: string }
  currency: string
  availableCountries: string[]
}

export enum DemoContestStatuses {
  draft = 'new',
  new = 'registration',
  registration = 'active',
  active = 'ended',
  ended = 'results',
}
